import { render, staticRenderFns } from "./ModalRemoveRegra.vue?vue&type=template&id=27fd5f35&scoped=true"
import script from "./ModalRemoveRegra.vue?vue&type=script&lang=ts"
export * from "./ModalRemoveRegra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd5f35",
  null
  
)

export default component.exports